export const hardwareSpecLink =
	'https://share.planckunits.io/pocketfarm/spec-hw.pdf'
export const softwareSpecLink =
	'https://share.planckunits.io/pocketfarm/spec-web.pdf'
export const usageLink =
	'https://share.planckunits.io/pocketfarm/usage_20220215publish.pdf'
